<header>
  <a href="javascript:void(0)" onclick="window.location.href='home'" class="logo" >
    <img src="/assets/images/umbrella-logo-light.svg" alt="Umbrella Travel Light Logo" width="153px" height="152px" loading="lazy" class="light-logo-header">
    <img src="/assets/images/umbreall-logo-dark.svg" alt="Umbrella Travel Dark Logo" width="153px"  height="152px" loading="lazy" class="dark-logo-header">
  </a>
  <div class="container mx-auto ps-4 border-l border-l-gray-300 relative">
    <div class="top-contact py-7">
                <span>
                    <span class="font-semibold text-blue-950">Talk with us</span>
                    <span class="text-orange-500 mx-3 orange-divi font-normal">|</span>
                </span>
      <a href="mailTo:info&#64;umbrellatravel.com"
         class="text-sm email-id-top me-4 font-normal flex items-center hover:text-orange-500 transition">
        <span class="icon-envelope me-1"></span> info&#64;umbrellatravel.com
      </a>
      <a href="tel:917984949224"
         class="text-sm flex items-center phone-number-top font-normal hover:text-orange-500 transition">
        <span class="icon-phone me-1"></span> +27-(83) 200-4179
      </a>
    </div>
    <button class="menu-bar inline-flex items-center justify-center  text-white w-[130px] h-[60px] ">
      <span class="icon-grid-2 me-3"></span>
      <span>Menu</span>

    </button>
  </div>
</header>
